export const COOKIE_KEYS = {
  USER_NONCE: 'userNonce',
  USER_MENU_STATE: 'userMenuState',
  USER_COLOR_MODE: 'userColorMode',
} as const;
